var _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _polygon2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _ellipse, _ellipse2, _ellipse3, _path25, _path26, _path27, _rect34, _rect35, _rect36, _path28, _path29, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntro11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 810.13137,
    height: 595.28505,
    viewBox: "0 0 810.13137 595.28505",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "378.969 471.236 391.767 465.509 375.738 412.214 356.848 420.666 378.969 471.236",
    fill: "#ffb6b6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M564.73607,609.12462l19.14514-13.51987,5.28409,8.518,26.99976,1.32862a6.26129,6.26129,0,0,1,2.99339,11.57461l-23.66938,14.68318-9.30656-5.89473,3.63383,9.41378-8.92431,5.53615Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M902.65793,522.71821c0-5.36-1.8-9.71-4.01-9.72h-602.49c-2.22.01-4.01,4.36-4.02,9.72v220.643a2.00261,2.00261,0,0,1-1.8087,1.99364q-2.42566.23283-4.85127.43337c-.04,0-.08.01-.12006.01-.87994.08-1.75994.14-2.63995.21h-.01q-.679-1.2554-1.34226-2.5327a2.01127,2.01127,0,0,1-.22775-.92907V510.10822c0-1.48.06-2.97.16-4.44a56.88446,56.88446,0,0,1,.75-6.02c1.69-9.29,5.51-15.58,9.85-15.6h611a4.68255,4.68255,0,0,1,1.84.39,7.17335,7.17335,0,0,1,2.27,1.59,14.06971,14.06971,0,0,1,2.23,3.05c2.14,3.77,3.67,9.39,4.21,15.93,0,.06.01.12.01.18.14,1.62.21,3.27.2,4.92l.14,21.43.09,12.78.27,40.1.1,14.24.44,146.2h0a2,2,0,0,1-2,2h-8.04a2,2,0,0,1-2-2Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M738.942,383.7725H674.02269a3.4638,3.4638,0,0,0-3.45856,3.46749V489.79343h71.84539V387.24A3.46567,3.46567,0,0,0,738.942,383.7725Zm-32.24126,58.26961a7.70187,7.70187,0,0,1-7.66591-7.66586V422.5476a7.66589,7.66589,0,0,1,15.33177,0v11.82865a7.70174,7.70174,0,0,1-7.66586,7.66586Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M670.34128,486.51316v9.89437a1.93827,1.93827,0,0,0,1.93434,1.93428h68.42246a1.944,1.944,0,0,0,1.93428-1.93428v-9.89437Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M586.93184,240.95666a13.84437,13.84437,0,0,1-20.15786,6.65727l-91.638,63.839-2.53-25.44054,90.10176-58.376a13.91943,13.91943,0,0,1,24.22411,13.32027Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#ffb6b6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M381.75992,281.208s-9.92243,14.66169,5.64814,27.63636,78.68082,10.39344,88.86534,10.28192,56.91286-48.4504,56.91286-48.4504l-.30585-27.91746-56.41792,33.47592Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#00be82"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M376.14192,378.55l1,19s-2.95156,16.83046-.5241,20.46245c2.40919,3.61383,68.56844,8.99009,68.56844,8.99009s-2.07418-28.33643,1.66732-48.83262Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#ffb6b6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M579.18626,572.00255l-25.4668,22.29283-49.91314-102.081c-49.4955,8.51244-96.19,11.23939-136.57874.94186-13.67464-3.43841-22.03353-17.55828-18.67007-31.53767q.2358-.98017.54534-1.93955c4.83376-14.748,17.48681-25.183,27.45579-41.40388l72.81682,1.10609-8.13313,28.06226L511.97879,438.29c14.22532-1.84079,27.217,8.45582,29.01765,22.99812q.14259,1.1518.18634,2.313Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 209.63985,
    cy: 68.7623,
    r: 29.56777,
    fill: "#ffb6b6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M387.2401,261.36154l27.1109,3.18952a5.53215,5.53215,0,0,1,4.75821,4.31316l4.31148,19.72906,26.87663,31.65059s9.65111,18.0959,6.032,38.60463a145.27265,145.27265,0,0,1-11.20962,35.74761s-66.09607,27.03184-68.50885,23.41267-3.19581-20.0584-3.19581-20.0584l-8.50352-94.60221a33.94421,33.94421,0,0,1,9.75568-27.2753c2.14548-2.11031,4.26283-3.58753,5.98625-3.58753C384.54641,272.35408,384.047,263.59235,387.2401,261.36154Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#00be82"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "250.479 510.874 263.06 517.036 293.347 470.36 274.778 461.265 250.479 510.874",
    fill: "#ffb6b6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M475.55107,652.682l-25.84675-9.8129,35.474-106.54571c-48.19347-14.12994-84.54608-36.88948-116.28637-63.9051-10.76764-9.10364-18.8428-20.79481-9.67239-31.8691q.64305-.77657,1.343-1.50187c10.82894-11.11773,38.3116-8.97869,54.40006-19.15992l35.98156,38.41582L448.68965,468.594l67.5506,22.8987c13.58463,4.605,20.7218,19.56708,15.94133,33.41873q-.37865,1.09708-.85021,2.15914Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M444.98424,655.79431,466.609,664.8328l-4.40977,9.00177,13.217,23.581a6.26129,6.26129,0,0,1-8.2163,8.68473l-25.01367-12.25365.05045-11.01623-6.04536,8.07946-9.43115-4.62011Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M402.69734,492.65874a13.84439,13.84439,0,0,1-2.53382-21.077L355.7346,369.1171l25.43776,2.55777L420.55065,471.552a13.91943,13.91943,0,0,1-17.85331,21.10679Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#ffb6b6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M403.87078,283.57907s-12.40655-12.62922-28.20754.06381S349.8954,358.70761,347.988,368.71255s36.22125,65.37993,36.22125,65.37993l27.42521,5.22836-21.64129-61.92959Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#00be82"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M846.44263,223.72628H568.93775a9.0084,9.0084,0,0,0-8.99406,8.994V419.98175a9.00266,9.00266,0,0,0,8.99406,8.994H846.44263a9.00266,9.00266,0,0,0,8.99406-8.994V232.72029A9.0084,9.0084,0,0,0,846.44263,223.72628Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M844.12626,230.22252h-272.87a4.82047,4.82047,0,0,0-4.81,4.82v182.62a4.81831,4.81831,0,0,0,4.81,4.81h272.87a4.81831,4.81831,0,0,0,4.81-4.81v-182.62A4.82047,4.82047,0,0,0,844.12626,230.22252Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M790.97581,501.78477H628.633a2.98639,2.98639,0,0,1-2.92236-3.60156l2.519-11.96387a2.9993,2.9993,0,0,1,2.92188-2.37109H788.45725a2.9993,2.9993,0,0,1,2.92188,2.37109l2.519,11.96387a2.9864,2.9864,0,0,1-2.92236,3.60156Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 437.3701,
    y: 333.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 447.3701,
    y: 333.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 457.3701,
    y: 333.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 467.3701,
    y: 333.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 477.3701,
    y: 333.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 487.3701,
    y: 333.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 497.3701,
    y: 333.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 507.3701,
    y: 333.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 517.3701,
    y: 333.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 527.3701,
    y: 333.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 537.3701,
    y: 333.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 547.3701,
    y: 333.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 557.3701,
    y: 333.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 567.3701,
    y: 333.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 577.3701,
    y: 333.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 587.3701,
    y: 333.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 437.25194,
    y: 338.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 447.25194,
    y: 338.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 457.25194,
    y: 338.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 467.25194,
    y: 338.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 477.25194,
    y: 338.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 487.25194,
    y: 338.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 497.25194,
    y: 338.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 507.25194,
    y: 338.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 517.25194,
    y: 338.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 527.25194,
    y: 338.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 537.25194,
    y: 338.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 547.25194,
    y: 338.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 557.25194,
    y: 338.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 567.25194,
    y: 338.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 577.25194,
    y: 338.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 587.25194,
    y: 338.64507,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 485.25194,
    y: 344.64507,
    width: 40,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M825.33368,730.02018l-7.71-12.39-1.54,7.08008c-.27,1.24-.54,2.5-.79,3.75-2.18995-1.87012-4.52-3.6001-6.79981-5.26q-10.5-7.62012-20.99023-15.26l2.18994,12.7c1.3501,7.82007,2.76025,15.8,6.1001,22.94995.37011.81006.77,1.61011,1.20019,2.39014h32.54a10.48736,10.48736,0,0,0,.54-2.24011.77484.77484,0,0,0,.00976-.15C830.59394,738.74015,827.91376,734.1702,825.33368,730.02018Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#f0f0f0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M385.33368,730.02018l-7.71-12.39-1.54,7.08008c-.27,1.24-.54,2.5-.79,3.75-2.19-1.87012-4.52-3.6001-6.79981-5.26q-10.5-7.62012-20.99023-15.26l2.18994,12.7c1.3501,7.82007,2.76025,15.8,6.1001,22.94995.37011.81006.77,1.61011,1.20019,2.39014h32.54a10.48736,10.48736,0,0,0,.54-2.24011.77484.77484,0,0,0,.00976-.15C390.59394,738.74015,387.91376,734.1702,385.33368,730.02018Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#f0f0f0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.875,747.33519l-275.75.30733a1.19069,1.19069,0,0,1,0-2.38137l275.75-.30733a1.19069,1.19069,0,0,1,0,2.38137Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#cacaca"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M471.875,747.33519l-275.75.30733a1.19069,1.19069,0,0,1,0-2.38137l275.75-.30733a1.19069,1.19069,0,0,1,0,2.38137Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#cacaca"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M373.30625,194.76256c-4.77,1.42-9.22-2.57-12.54-6.35l1.18,1.4c-7.81,5.5-12.48,14.46-15.51,23.53-3.03,9.06-4.72,18.55005-8.14,27.48-3.42,8.92-8.94,17.55-17.39,22-11.32,5.96-25.19,3.25-37.23-1.05-.16-.06-.31-.11-.47-.17a76.72191,76.72191,0,0,0,8.78-29.4,69.75875,69.75875,0,0,1-20.86,24.47,160.14026,160.14026,0,0,1-22.62-12.58c-4.65-3.11-9.55-7.13-10.09-12.7-.55-5.53,3.58-10.58,8.45-13.24,4.87-2.66,10.47-3.56,15.79-5.16,5.31-1.59,10.73-4.2,13.52-9,6.43-11.04-4.39-26.61,2.51-37.37,3.4-5.29,10-7.41,16.12-8.88a213.11684,213.11684,0,0,1,28.38-4.79c8.39-.84,17.06-1.15,25.04,1.55,7.98,2.7,15.22,8.97,16.93,17.23,4.66,2.45,9.59,5.16,12.09,9.81C379.74625,186.18254,378.35624,193.26256,373.30625,194.76256Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M366.18566,192.90224c-4.56758,5.72185-7.05391,11.9097-7.05391,15.61541-9.48863,17.34214,4.08027,32.23829,21.42278,41.7267a35.53011,35.53011,0,0,0,22.70045,3.95754l.72556-3.09718.983,2.78992s11.29118,37.29294,15.01558,39.48063c-1.4133-6.63689-3.03222-37.36661-3.819-43.84379-1.08923-8.81581,2.70778-21.94031,5.44676-29.92165a47.11141,47.11141,0,0,0,2.57936-15.28924v-.22752l2.667,8.56653,9.70947-4.14194c-1.80639-10.361,0-22.12312-21.65623-21.103-11.7127-8.05537-22.02711-9.28241-30.49972-6.99772-1.09343-1.69049-7.39851,1.47574-9.22049.5856",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M848.93626,235.04252v182.62a4.81831,4.81831,0,0,1-4.81,4.81h-96.22a118.07647,118.07647,0,0,1-25.76-34.66q-.63008-1.26-1.2-2.55a117.02853,117.02853,0,0,1-10.4-40.03c-.07-.85-.13-1.7-.17-2.56-.13-2.2-.19-4.43-.19-6.67a117.53522,117.53522,0,0,1,8.29-43.51c.33-.86.68-1.71,1.04-2.56a118.399,118.399,0,0,1,56.35-59.71h68.26A4.82047,4.82047,0,0,1,848.93626,235.04252Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#00be82"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M830.40955,255.38347H575.08619a1.01559,1.01559,0,0,1,0-2.03069H830.40955a1.01559,1.01559,0,0,1,0,2.03069Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#cacaca"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 397.53206,
    cy: 89.7281,
    rx: 5.95043,
    ry: 6.08304,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 418.08808,
    cy: 89.7281,
    rx: 5.95043,
    ry: 6.08304,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 438.64411,
    cy: 89.7281,
    rx: 5.95043,
    ry: 6.08304,
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M818.03308,237.51029H803.43116a1.10584,1.10584,0,0,0,0,2.21125h14.60192a1.10584,1.10584,0,0,0,0-2.21125Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M818.03308,241.66048H803.43116a1.10584,1.10584,0,0,0,0,2.21125h14.60192a1.10584,1.10584,0,0,0,0-2.21125Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M818.03308,245.80522H803.43116a1.10584,1.10584,0,0,0,0,2.21125h14.60192a1.10584,1.10584,0,0,0,0-2.21125Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#3f3d56"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 420.18539,
    y: 162.34385,
    width: 40.58192,
    height: 8.67797,
    rx: 4.33898,
    fill: "#00be82"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 399.57522,
    y: 179.69979,
    width: 81.80226,
    height: 8.67797,
    rx: 4.33898,
    fill: "#e6e6e6"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 399.57522,
    y: 197.05572,
    width: 81.80226,
    height: 8.67797,
    rx: 4.33898,
    fill: "#e6e6e6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M601.18626,412.00255a29.81518,29.81518,0,0,1-1.88,10.47h-28.05a4.81831,4.81831,0,0,1-4.81-4.81v-35.28a29.62789,29.62789,0,0,1,4.74-.38A29.99813,29.99813,0,0,1,601.18626,412.00255Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#00be82"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M849.18626,292.49254v-2.56h-42.91v-29.67h-2.55005v29.67h-49.18v-29.67h-2.55v29.67h-32.48c-.36.85-.71,1.7-1.04,2.56h33.52v50.18h-41.62c.04.86.1,1.71.17,2.56h41.45v40.03h-31.05q.57,1.29,1.2,2.55h29.85v33.65h2.55v-33.65h49.18v33.65h2.55005v-33.65h42.91v-2.55h-42.91v-40.03h42.91v-2.56h-42.91v-50.18Zm-45.46,92.77h-49.18v-40.03h49.18Zm0-42.59h-49.18v-50.18h49.18Z",
    transform: "translate(-194.93432 -152.35748)",
    opacity: 0.2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M814.63715,403.52634a2.67228,2.67228,0,0,1-1.93671-4.63171l.18311-.728q-.03617-.08744-.07276-.17474a7.17622,7.17622,0,0,0-13.23736.04919c-2.165,5.21442-4.92151,10.43775-5.60022,15.95111a21.22989,21.22989,0,0,0,.37268,7.30139,85.1153,85.1153,0,0,1-7.74262-35.35113,82.15391,82.15391,0,0,1,.50958-9.16486q.42216-3.742,1.17133-7.43078a86.10146,86.10146,0,0,1,17.07471-36.492,22.914,22.914,0,0,0,9.5299-9.88739,17.47837,17.47837,0,0,0,1.5896-4.77636c-.46392.06085-.93548.09887-1.39941.12927-.14453.00757-.29663.0152-.44116.02283l-.05451.00244a2.64762,2.64762,0,0,1-2.17443-4.31342q.30047-.36978.60131-.7392c.30426-.38031.61609-.753.92029-1.13324a1.31835,1.31835,0,0,0,.09888-.11413c.34991-.43353.69971-.85944,1.04962-1.293a7.65593,7.65593,0,0,0-2.50989-2.42615c-3.50622-2.05353-8.34344-.63128-10.87616,2.54029-2.54028,3.1715-3.01941,7.62091-2.1372,11.58343a30.68156,30.68156,0,0,0,4.244,9.46143c-.19018.2434-.38794.47918-.57806.72259a86.65765,86.65765,0,0,0-9.04486,14.32923,36.02437,36.02437,0,0,0-2.1507-16.73261c-2.05859-4.96613-5.91711-9.14862-9.315-13.44183-4.08142-5.1568-12.45074-2.90625-13.1698,3.6308q-.01044.09493-.02038.18981.757.4271,1.48211.90662a3.62476,3.62476,0,0,1-1.46142,6.59638l-.07392.01141a36.06687,36.06687,0,0,0,.95069,5.39245,37.13416,37.13416,0,0,0,18.48938,23.27338c.29663.1521.58569.3042.88232.44873a88.45163,88.45163,0,0,0-4.76117,22.40631,83.89412,83.89412,0,0,0,.06085,13.54572l-.02282-.15973a22.16826,22.16826,0,0,0-7.56769-12.80035c-5.82373-4.784-14.05158-6.54566-20.33435-10.39106a4.16035,4.16035,0,0,0-6.372,4.04737q.01263.084.02569.1679a24.35134,24.35134,0,0,1,2.73041,1.31574q.75705.42718,1.48212.90662a3.62479,3.62479,0,0,1-1.46143,6.59643l-.074.01135c-.05322.00763-.09888.01526-.152.02289a36.09715,36.09715,0,0,0,6.63971,10.39691,37.16717,37.16717,0,0,0,26.95453,11.82685h.00763a88.42639,88.42639,0,0,0,5.94006,17.34094h21.21979c.07611-.23578.14453-.47919.213-.715a24.10928,24.10928,0,0,1-5.87164-.34979c1.5744-1.93188,3.14874-3.879,4.72314-5.81079a1.31793,1.31793,0,0,0,.09888-.11408c.79858-.9887,1.6048-1.96984,2.40338-2.95855l.00043-.00122a35.31507,35.31507,0,0,0-1.03479-8.99634Zm-24.2995-47.80127.01117-.01507-.01117.03027Zm-4.70026,42.37122-.18256-.41065c.00763-.29663.00763-.59326,0-.89746,0-.08374-.01519-.16736-.01519-.251.06842.52479.12927,1.04963.20532,1.57441Z",
    transform: "translate(-194.93432 -152.35748)",
    fill: "#2f2e41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntro11);
export default __webpack_public_path__ + "static/media/intro11.0ec3ae00f140ed54387725ea20b76f96.svg";
export { ForwardRef as ReactComponent };